import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface, ClientRelation } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UpdateParticipantUseCaseParams {
    client: ClientInterface;
}

@Injectable()
export class UpdateParticipantUseCase implements UseCaseWithParam<UpdateParticipantUseCaseParams, Observable<Transaction<void>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(params: UpdateParticipantUseCaseParams): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (contract) => {
                        contract.holders.map((holder, idx) => {
                            if (holder.id.value === params.client.id.value) {
                                if (params.client.relation === ClientRelation.AUTHORIZED) {
                                    contract.removeHolder(holder);
                                    contract.addAuthorized(params.client);
                                } else {
                                    contract.holders[idx] = params.client;
                                }
                            } else {
                                holder.legalGuardians.map((legalGuardian, idx2) => {
                                    if (legalGuardian.id.value === params.client.id.value) {
                                        contract.holders[idx].legalGuardians[idx2] = params.client;
                                    }
                                });
                            }
                        });

                        contract.authorized.map((authorize, idx) => {
                            if (authorize.id.value === params.client.id.value) {
                                if (params.client.relation === ClientRelation.HOLDER) {
                                    contract.removeAuthorized(authorize);
                                    contract.addHolder(params.client);
                                } else {
                                    contract.authorized[idx] = params.client;
                                }
                            }
                        });

                        return Transaction.success();
                    },
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
